module.exports = __webpack_public_path__ + "img/backIdCardImg.08759e36.png";